<phx-dialog
  [phxWidth]="modalWidth"
  [phxFullHeight]="phxFullScreen"
  [phxFullWidth]="phxFullScreen"
  [phxBackdrop]="!(phxFullScreen || isMobileView)"
  [phxPlacement]="isMobileView ? 'bottom' : 'center'"
  [phxOffset]="phxOffset"
  [phxOpen]="phxOpen"
  (phxOpenChange)="phxOpenChange.emit($event)"
  (phxBackdropClicked)="onBackdropClicked()"
  (phxKeydown)="onKeydown($event)"
>
  <div
    class="phx-modal"
    [ngClass]="{
      'phx-modal-dark': phxBackground === PHX_BACKGROUND.DARK,
      'phx-modal-fullscreen': phxFullScreen
    }"
  >
    <div class="phx-modal-header-container">
      <div class="phx-modal-header">
        <div class="phx-modal-header-prefix">
          <ng-content select="[phx-modal-header-prefix]"></ng-content>
        </div>
        <ng-content select="[phx-modal-header]"></ng-content>
     <ng-container *ngIf="!isMobileView" [ngTemplateOutlet]="headerSelect"></ng-container>
        <div class="phx-modal-header-suffix">
          <ng-content select="[phx-modal-header-suffix]"></ng-content>
        </div>
        <button
          *ngIf="!phxHideCloseIcon"
          class="phx-modal-header-cross-icon"
          phx-icon-button
          [phxIcon]="CloseIcon"
          [phxIconButtonSize]="isMobileView ? 'extra-large' : 'small'"
          [phxIconButtonType]="phxBackground === 'dark' ? 'on-bold' : 'default'"
          (click)="closeIconClicked()"
        ></button>
      </div>
      <ng-container *ngIf="isMobileView" [ngTemplateOutlet]="headerSelect"></ng-container>
      <ng-content select="[phx-modal-header-extra]"></ng-content>
    </div>
    <ng-content select="[phx-modal-body]"></ng-content>
    <ng-content select="[phx-modal-footer]"></ng-content>
  </div>
</phx-dialog>

<ng-template #headerSelect>
  <div class="phx-modal-header-select">
    <ng-content select="[phx-modal-header-select]"></ng-content>
  </div>
</ng-template>
